// Vollea web API client (fetch + localStorage token, REACT_APP_BACKEND_URL)
const BASE = process.env.REACT_APP_BACKEND_URL || "";
const TOKEN_KEY = "vollea_token";

export const getToken = () => localStorage.getItem(TOKEN_KEY) || "";
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

async function req(path, opts = {}) {
  const token = getToken();
  const isForm = opts.body instanceof FormData;
  const headers = { ...(opts.headers || {}) };
  if (!isForm) headers["Content-Type"] = "application/json";
  if (token) headers["Authorization"] = `Bearer ${token}`;
  const res = await fetch(`${BASE}/api${path}`, { ...opts, headers });
  let data = null;
  try { data = await res.json(); } catch {}
  if (!res.ok) {
    if (res.status === 401) {
      clearToken();
      const p = window.location.pathname;
      // /auth-callback handles its own 401 surfacing (shows the error in-place)
      // so we MUST NOT trigger the global hard-redirect there — otherwise the
      // OAuth failure UI never mounts. Same exemption applies when the URL hash
      // contains session_id= (Shell mounts AuthCallback from the hash on any
      // pathname), so the two callsites stay in sync.
      const hashHasSession = typeof window !== "undefined" && window.location.hash?.includes("session_id=");
      if (
        p !== "/" &&
        !p.startsWith("/login") &&
        !p.startsWith("/register") &&
        !p.startsWith("/forgot-password") &&
        !p.startsWith("/auth-callback") &&
        !hashHasSession
      ) {
        window.location.href = "/login";
      }
    }
    let msg;
    const detail = data?.detail;
    if (typeof detail === "string") {
      msg = detail;
    } else if (Array.isArray(detail) && detail.length > 0) {
      // FastAPI validation errors: [{loc:["body","sets"], msg:"field required", ...}]
      msg = detail.map((d) => d?.msg || "validation error").join("; ");
    } else if (detail) {
      msg = JSON.stringify(detail);
    } else {
      msg = `Request failed (${res.status})`;
    }
    throw new Error(msg);
  }
  return data;
}

export const api = {
  get: (p) => req(p),
  post: (p, body) => req(p, { method: "POST", body: body instanceof FormData ? body : JSON.stringify(body || {}) }),
  put: (p, body) => req(p, { method: "PUT", body: JSON.stringify(body || {}) }),
  del: (p) => req(p, { method: "DELETE" }),
};

export async function login(email, password) {
  const data = await api.post("/auth/login", { email, password });
  if (data?.token) setToken(data.token);
  return data;
}
export async function register({ email, password, name, role = "player", invite_code }) {
  const data = await api.post("/auth/register", { email, password, name, role, invite_code });
  if (data?.token) setToken(data.token);
  return data;
}
export async function googleSession(session_id, invite_code) {
  // Backend exchanges the session_id with Emergent's /session-data endpoint.
  const data = await api.post("/auth/session", { session_token: session_id, invite_code: invite_code || undefined });
  if (data?.token) setToken(data.token);
  return data;
}
export async function me() { return api.get("/auth/me"); }
export async function logoutApi() {
  try { await api.post("/auth/logout"); } catch {}
  clearToken();
}
